import { useTranslation } from 'react-i18next';


const ContactSection = () => {

    const { t } = useTranslation();

    return (
        <div className="container">
            <figure className="mx-auto my-5 d-flex align-items-center justify-content-center">
                <img src="https://pro-static.h10hotels.com/gallery/MICE65px.svg" alt="Reuniones y Eventos" />
            </figure>
            <div className="row justify-content-center">
                <div className="col-md-6">
                    <p className="mb-3 text-xl text-center">
                        <strong className="fw-semibold"> Where working becomes a pleasure</strong>
                    </p>
                    <p className="text-sm text-center">Contáctanos para obtener más información sobre nuestros hoteles especializados en la organización de reuniones y eventos. Si tienes interés en un hotel o destino específico, por favor, háznoslo saber para que podamos proporcionarte todos los detalles necesarios.</p>
                    <p className="text-sm text-center">
                        <strong className="fw-semibold">Contacta con nosotros:</strong>
                    </p>
                    <p className="text-sm text-center">mice@h10hotels.com</p>
                    <p className="text-sm text-center">(+34) 628 171 237</p>
                </div>
            </div>
            <div className="c-swiper-hotels_overflow">
                <swiper-container init="false" className="mt-6" style={{ display: "flex" }}>
                    <div style={{ width: "664px", marginRight: "16px" }} role="group" aria-label="1 / 2">
                        <div className="c-card-hotel c-card-hotel_events">
                            <figure className="c-card-hotel_img">
                                <img alt="" className="c-card-hotel_img-logo" src="https://pro-static.h10hotels.com/gallery/MICE65px.svg" />
                                <img alt="" src="https://pro-static.h10hotels.com/gallery/01_HCGCubismoMeetingRoomSchool2.jpg" />
                            </figure>
                            <div className="c-card-hotel_body">
                                <p className="text-xl o-title-lineleft">REUNIONES Y EVENTOS</p>
                                <p className="text-sm text-gray">Los establecimientos de H10 Hotels son idóneos para la organización de cualquier tipo de evento. Te ofrecemos lugares excepcionales en 20 destinos. Desde hoteles de ciudad, con ubicaciones céntricas, a hoteles emplazados en primera línea de mar. Disponemos de amplios salones de reuniones, la tecnología más avanzada y una gastronomía de primer nivel. Si estás pensando en un evento en un lugar especial, H10 Hotels es la mejor opción.</p>

                            </div>
                        </div>
                    </div>
                    <div style={{ width: "664px", marginRight: "16px" }} role="group" aria-label="2 / 2">
                        <div className="c-card-hotel c-card-hotel_events">
                            <figure className="c-card-hotel_img">
                                <img alt="" className="c-card-hotel_img-logo" src="https://pro-static.h10hotels.com/gallery/PerfectDay.svg" />
                                <img alt="" src="https://pro-static.h10hotels.com/gallery/13_HASBanquetDetail7.jpg" />
                            </figure>
                            <div className="c-card-hotel_body">
                                <p className="text-xl o-title-lineleft">PERFECT DAY</p>
                                <p className="text-sm text-gray">Tu boda es uno de los momentos más importantes de tu vida. Es el inicio de una aventura, un día para emocionaros, compartir experiencias y crear recuerdos inolvidables junto a tus seres queridos. Por ello, en H10 Hotels ofrecemos todos los servicios necesarios para organizar la celebración que siempre habías soñado: ubicaciones privilegiadas frente al mar o en la ciudad, un interiorismo cuidado al detalle y una gastronomía excepcional, todo ello acompañado de un equipo de profesionales que te guiarán para que tu enlace se convierta en el día perfecto.</p>
                                <a className="btn btn-outline-primary btn-xs-full" href="/es/hoteles-bodas-celebraciones">MÁS INFORMACIÓN</a>

                            </div>
                        </div>
                    </div>
                </swiper-container>
            </div>
            <div className="mt-6 mb-8 row">
                <div className="col-md-6">
                    <figure className="o-cont-fullw o-cont-md-fullw__left ratio ratio-16x9">
                        <img className="w-100" src="https://pro-static.h10hotels.com/gallery/04_HPAOsEspelhosMeetingRoom3.jpg" alt="Sala Os Espelhos" />
                    </figure>
                </div>
                <div className="col-md-6 d-flex flex-column justify-content-center align-items-start">
                    <h3 className="mb-3 text-center text-md-start h1 h1-lg-vw"> We love meeting you </h3>
                </div>

                <div className="col-lg-9 offset-lg-3">
                    <div className="row justify-content-end">
                        <div className="col-xs-6 col-md-4">

                            <div className="c-card basic">
                                <a className="c-card_img">
                                    <img alt="" src="https://pro-static.h10hotels.com/gallery/01_HITTeatreMeetingRoom.jpg" />
                                </a>
                                <p>

                                    <a href="https://www.youtube.com/watch?v=jfmbD5vfZoM" rel="noopener noreferrer" target="_blank">
                                        <strong>
                                            <u>Accede al vídeo</u>
                                        </strong>
                                    </a>
                                    <span style={{ color: "rgb(58, 64, 91)" }}> de nuestros Meetings &amp; Events Hotels.</span>

                                </p>
                                <a className="btn btn-link" href="https://youtu.be/1t7v7K-bN58"> MÁS INFORMACIÓN <span className="o-icon o-icon-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                </span>
                                </a>

                            </div>

                        </div>
                        <div className="col-xs-6 col-md-4">

                            <div className="c-card basic">
                                <a className="c-card_img">
                                    <img alt="" src="https://pro-static.h10hotels.com/gallery/08_HMILesCotxeres5.jpg" />
                                </a>
                                <p>

                                    <span style={{ color: "rgb(58, 64, 91)" }}>¿Quieres más información? Consulta nuestro </span>
                                    <a href="https://drive.google.com/file/d/12t5X1OIKVHBcrXSTkQmEkvjjD2NcazP1/view?usp=sharing" rel="noopener noreferrer" target="_blank">
                                        <strong>
                                            <u>directorio M&amp;E H10 Hotels</u>
                                        </strong>
                                    </a>
                                    <a href="https://drive.google.com/file/d/12t5X1OIKVHBcrXSTkQmEkvjjD2NcazP1/view?usp=sharing" rel="noopener noreferrer" target="_blank" style={{ color: "rgb(58, 64, 91)" }}>.</a>
                                </p>
                                <a className="btn btn-link" href="https://drive.google.com/file/d/12t5X1OIKVHBcrXSTkQmEkvjjD2NcazP1/view?usp=sharing"> MÁS INFORMACIÓN <span className="o-icon o-icon-2">
                                    <i className="fa-solid fa-arrow-right"></i>
                                </span>
                                </a>

                            </div>

                        </div>

                    </div>
                </div>

            </div>
        </div>
    );
}

export default ContactSection;
